import { Component, Input } from '@angular/core';

import { ParticipantsService } from '../../../../services/participants/participants.service';
import { Environment } from '../../../../services/enviroment/environment.model';
import { EnvironmentService } from '../../../../services/enviroment/environment.service';
import { TranslatePipe } from '@ngx-translate/core';
import { NgStyle } from '@angular/common';
import { InviteParticipantsComponent } from '../invite-participants/invite-participants.component';

@Component({
  selector: 'sas-participants-tooltip',
  standalone: true,
  imports: [TranslatePipe, NgStyle, InviteParticipantsComponent],
  templateUrl: './participants-tooltip.component.html',
  styleUrls: ['./participants-tooltip.component.scss']
})
export class ParticipantsTooltipComponent {

  @Input() participantsData: any;
  public showInviteForm = false;
  public config: Environment;

  constructor(
    private readonly participantsSvc: ParticipantsService,
    private readonly enviromentSvc: EnvironmentService
  ) {
    this.config = this.enviromentSvc.data;
  }

  closeToolTipUsers() {
    this.participantsSvc.setCloseOpenUserList(false);
    this.showInviteForm = false;
  }

  closeToolTipForm(event:any) {
    this.showInviteForm = event;
  }

}
